import { computed, ref, watch, onMounted, onActivated } from 'vue'
import { readPendingCreateActivityId } from '@/constants/eventCreateGate'

/**
 * 活动 ID 解析顺序（优先级从高到低）：
 * 1. 路由 params.id（如 /conference/events/123/edit）
 * 2. sessionStorage 中的待创建草稿 id（仅 /conference/events/create 无 :id 时由活动信息保存写入）
 */
export function useActivityIdFromRouteOrSession (route) {
  const sessionActivityId = ref(readPendingCreateActivityId())

  const refreshFromSession = () => {
    sessionActivityId.value = readPendingCreateActivityId()
  }

  onMounted(refreshFromSession)
  onActivated(refreshFromSession)
  watch(() => route.fullPath, refreshFromSession)

  const activityId = computed(() => {
    const rid = Number(route.params?.id)
    if (Number.isInteger(rid) && rid > 0) return rid
    const sid = Number(sessionActivityId.value)
    return Number.isInteger(sid) && sid > 0 ? sid : null
  })

  return { activityId, refreshFromSession }
}
